const normalizeStatus = (
  status
) =>
  String(status || "")
    .trim()
    .toLowerCase()
    .replace(
      /[_\s]+/g,
      "-"
    );

const StatusBadge = ({
  status,
  label,
  className = "",
}) => {
  const normalizedStatus =
    normalizeStatus(status);

  const displayLabel =
    label ||
    String(status || "")
      .replace(
        /[_-]+/g,
        " "
      )
      .replace(
        /\b\w/g,
        (character) =>
          character.toUpperCase()
      );

  return (
    <span
      className={[
        "app-status-badge",
        `app-status-${normalizedStatus}`,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {displayLabel}
    </span>
  );
};

export default StatusBadge;